import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "nav" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" | ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routesValue, ({ name, path}) => {
      return (_openBlock(), _createBlock(_component_router_link, {
        key: path,
        to: path
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(name), 1)
        ]),
        _: 2
      }, 1032, ["to"]))
    }), 128)),
    _hoisted_2
  ]))
}